import { createContext, type ReactNode } from 'react';
import { getEnvironment } from './get-environment';

export const InstanceContext = createContext<string | undefined>('dev');

export function InstanceProvider({
  instanceId,
  children,
}: {
  instanceId: string | undefined;
  children: ReactNode;
}) {
  const environment = getEnvironment();
  const resolvedInstanceId = instanceId === undefined && environment === 'dev' ? 'dev' : instanceId;
  return <InstanceContext.Provider value={resolvedInstanceId}>{children}</InstanceContext.Provider>;
}
